import useDownloadImage from "./useDownloadImage";
import {Avatar} from "@mui/material";
import AllOut from "@mui/icons-material/AllOut";
import React from "react";


export default ({image_url, bucket}: { image_url: string | null, bucket: string }) => {
    const imageUrl = useDownloadImage(bucket, image_url)
    if (imageUrl) {
        return <Avatar src={imageUrl}/>
    }
    return <Avatar><AllOut/></Avatar>
}
